import { lazy } from 'react';
import { promiseRetry } from '@olxeu-a2b/delivery-utils/src/extras';

export default lazy(() =>
  promiseRetry(() => import(/* webpackChunkName: "benefits" */ './BenefitsContainer'), 5, 500),
);
